import { RequestSummaryCardsProps } from "../types/requestSummaryCardsProps";
import { DetailsSection } from "./DetailCard";

export function RequestSummaryCards({ request }: RequestSummaryCardsProps) {
  console.log(" request", request);

  const consumerDetails = [
    { label: "Account No", value: request?.customer?.consumerNo ?? "NA" },
    {
      label: "Name",
      value: request?.customer?.firstName + " " + request?.customer?.lastName,
    },
    { label: "Email", value: request?.customer?.email },
    { label: "Phone", value: request?.customer?.phone },
    { label: "Category", value: request?.customer?.categoryDisplay },
    { label: "Sub-Category", value: request?.customer?.subCategoryDisplay },
    { label: "Account Type", value: request?.customer?.ownershipDisplay },
    ...(request?.customer?.ownershipDisplay?.toLowerCase() === "sub-account"
      ? [
          {
            label: "Master Account",
            value: request?.customer?.masterAccountNo || "NA",
          },
        ]
      : []),
  ];

  const auditInfo = [
    { label: "Created By", value: request?.requestedBy ?? "NA" },
    { label: "Created On", value: request?.dateRequested ?? "NA" },
    { label: "Last Updated By", value: request?.lastUpdatedBy ?? "NA" },
    { label: "Last Updated On", value: request?.lastUpdatedOn ?? "NA" },
    {
      label: "Resolved By",
      value: request?.resolvedBy || "Pending",
    },
    {
      label: "Resolved On",
      value: request?.resolvedOn || "Pending",
    },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-6">
      <div className="lg:col-span-4 space-y-6">
        <DetailsSection title="Consumer Details" fields={consumerDetails} />
        <DetailsSection title="Audit Info" fields={auditInfo} columns={3} />
      </div>
    </div>
  );
}
